/**
 * @ Author: mzc
 * @ Create Time: 2024-07-03 19:51:46
 * @ Modified by: mzc
 * @ Modified time: 2024-07-09 14:51:59
 * @ Description: 批量充值订单
 */
import dayjs from "dayjs";

const initalState = {
	option: {
		// time: [dayjs().subtract(30, "day").format("YYYY-MM-DD"), dayjs().format("YYYY-MM-DD")],
		time: [],
		page: 1,
		pageSize: 20,
		status: [],
		batch_id: ""
	},
	
};
const rechargeOrdersReducer = (state = initalState, action) => {
	switch (action.type) {
		case "RECHARGEORDERS_UPDATEOPTION":
			return { ...state, option: { ...action.payload } };
		case "RECHARGEORDERS_RESET":
			return { ...JSON.parse(JSON.stringify(initalState)) };
		default:
			return state;
	}
};

export default rechargeOrdersReducer;
